<div *ngIf="!clientCardLoader && currPOS && currSM">

    <div *ngIf="(currPaymentMethod === 'card' || currPaymentMethod === 'secure_counter') && currCard$ " fxLayout="row"
        fxLayoutAlign="end center" style="padding-bottom: 10px;">
        <span *ngIf="(currPaymentMethod === 'card' || currPaymentMethod === 'secure_counter') && currCard$"
            class="mat-subheading-1 boldest primary-ico clicked" (click)="openDialogCard()"
            [class.isDisabled]="clientCardLoader || (creditMode && clientCumul >= 0 )">{{'button.modify'|translate}}</span>

    </div>

    <!-- Parcours des différents modes de paiement possible -->
    <div *ngFor="let item of paymentsMethods" style="margin-bottom: 10px;">

        <mat-radio-group *ngIf="item.visible" (change)="setPaymentMethod($event.value)"
            [disabled]="creditMode && clientCumul>=0">

            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
                [ngClass]="cssService.sectionCardClass" class="clicked" (click)="setPaymentMethod(item.paiment_type)"
                [class.noHeight]="item.name === 'counter' || item.name === 'secure_counter'">

                <!-- card -->
                <div *ngIf="item.name === 'card'" class="flex flex-row justify-start items-center gap-2.5">
                    <img [src]="currCard$?.card?.logo_src" class="h-10"
                        *ngIf="currCard$?.card?.brand !== 'visa' && currCard$?.card?.brand !== 'mastercard'">
                    <img src="assets/img/refonte-logo/VISA.png" class="rad-bord h-10"
                        *ngIf="currCard$?.card?.brand === 'visa'">
                    <img src="assets/img/refonte-logo/MASTERCARD.png" class="rad-bord h-10"
                        *ngIf="currCard$?.card?.brand === 'mastercard'">

                    <span class="mat-subheading-1 boldest">{{currCard$?.card?.brand | capitalize}}</span>

                    <div style="padding-left: 10px;">
                        <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** ****
                            {{currCard$?.card?.last4}}</span>
                        <span class="mat-subheading-1" style="color:grey" fxHide fxShow.xs>****
                            {{currCard$?.card?.last4}}</span>
                    </div>
                </div>

                <!-- stripe -->
                <div *ngIf="item.name === 'stripe'" class="flex flex-row justify-start items-center gap-2.5">
                    <img src="assets/img/refonte-logo/STRIPE.png" class="rad-bord h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                </div>

                <!-- Paypal -->
                <div *ngIf="item.name === 'online_paypal'" class="flex flex-row justify-start items-center gap-2.5">
                    <img src="assets/img/refonte-logo/PAYPAL.png" class="rad-bord h-10">
                    <span class="mat-subheading-1 boldest">Paypal</span>
                </div>

                <!-- Payzen -->
                <div *ngIf="item.name === 'payzen'" class="flex flex-row justify-start items-center gap-2.5">
                    <img src="assets/img/refonte-logo/PAYZEN.png" class="rad-bord h-10">
                    <span class="mat-subheading-1 boldest">Payzen</span>
                </div>

                <!-- counter  || secure_counter-->
                <div fxLayout="column" *ngIf="item.name === 'counter'|| item.name === 'secure_counter'">

                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <img src="assets/img/refonte-logo/PAIEMENT_COMPTOIR.png" class="rad-bord h-10">

                        <span class="mat-subheading-1 boldest"
                            *ngIf="currSM && currSM.enable_delivery && currSM.enable_delivery <1">{{"endorder.counter-payment"
                            | translate}}</span>
                        <span class="mat-subheading-1 boldest"
                            *ngIf="currSM && currSM.enable_delivery && currSM.enable_delivery> 0">{{"endorder.delivry-payment"
                            | translate}}</span>
                    </div>
                    <!-- counter message -->
                    <div
                        *ngIf="currSM && currSM.enable_delivery && currSM.enable_delivery <1 && item.name === 'counter'">
                        <span class="mat-caption">{{"endorder.counter-payment-msg" |
                            translate}}</span>
                    </div>


                    <!-- secure_counter  -->
                    <div *ngIf=" item.name === 'secure_counter'">

                        <div fxLayout="column">

                            <div fxLayout="column" *ngIf="currSM.enable_delivery && currSM.enable_delivery <1">
                                <span class="mat-caption">{{"endorder.counter-secure-payment-msg"
                                    | translate}}</span>
                                <span class="mat-caption secondary-ico">{{"endorder.counter-payment-beforehand-msg"
                                    | translate}}
                                </span>
                            </div>

                            <div fxLayout="column" *ngIf="currSM.enable_delivery && currSM.enable_delivery> 0">
                                <span class="mat-caption">{{"endorder.delivry-payment-msg"
                                    | translate}}
                                </span>
                            </div>

                            <div fxLayout="column" *ngIf="currPaymentMethod === 'secure_counter'">

                                <app-cards-endorder id="paimentcard" [clientCards$]="clientCards" [from]="'order'"
                                    [showDelete]="false" (setClientCardsEvent)="setClientCards($event)">
                                </app-cards-endorder>

                                <!-- Error message -->
                                <div fxLayout="row" fxFlex
                                    *ngIf="!clientCards ||(clientCards && clientCards.length === 0)" id="cardneeded">
                                    <span class="mat-caption boldest warn-ico">{{"endorder.requiredCard" |
                                        translate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--touch_terminal borne-->
                <div *ngIf="item.name === 'touch_terminal'" fxLayout="row" fxLayoutAlign="start center"
                    fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/payment.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"header.menu.borne"|translate}}</span>
                </div>

                <!--myPos-->
                <!-- <div *ngIf="item.name === 'myPos'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/PAIEMENT-EN-LIGNE.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                    <span class="logcard"> M </span>
                </div> -->

                <!--yavin-->
                <!-- <div *ngIf="item.name === 'yavin'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/PAIEMENT-EN-LIGNE.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                    <span class="logcard">Y</span>
                </div> -->

                <!-- Nepting -->
                <!-- <div *ngIf="item.name === 'nepting'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/PAIEMENT-EN-LIGNE.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                    <span class="logcard">N</span>
                </div> -->

                <!--myPos-->
                <div *ngIf="item.name === 'myPos'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/MY_POS.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                </div>

                <!--yavin-->
                <div *ngIf="item.name === 'yavin'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/YAVIN_NEW.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                </div>

                <!-- Nepting -->
                <div *ngIf="item.name === 'nepting'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <img src="assets/img/refonte-logo/NEPTING_NEW.png" class="h-10">
                    <span class="mat-subheading-1 boldest">{{"endorder.online-payment"|translate}}</span>
                </div>

                <div fxLayout="row" fxLayoutAlign="end center">
                    <mat-radio-button color="primary" [value]="item.paiment_type"
                        [checked]="currPaymentMethod === item.paiment_type">
                    </mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
    </div>
    <div *ngIf="!hasVisiblePaymentMethods()" class=" warn-ico">Aucun type de paiement n'est présent</div>
</div>